import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
} from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';

import { SocialAccount } from 'api';
import { Numeric, SocialAccountIcon } from 'components';
import { connectionPopup, getSocialAccountName } from 'helpers';
import { useCurrentUser } from 'hooks';

import styles from './itemStyles';

interface IProps extends WithStyles<typeof styles> {
  account: SocialAccount;
}

const ReachItem: FC<IProps> = ({ classes, account }) => {
  const { t } = useTranslation();
  const { id } = useCurrentUser();

  function renderRefresh() {
    return (
      <Button
        size="small"
        className={classes.refreshButton}
        onClick={() => connectionPopup(id, account.provider)}>
        {t('common:refresh')}
      </Button>
    );
  }

  function renderValue() {
    return (
      <Typography color="textSecondary">
        <Numeric value={account.reach} />
      </Typography>
    );
  }

  return (
    <ListItem disableGutters>
      <SocialAccountIcon active provider={account.provider} />
      <ListItemText disableTypography>
        <Typography variant="body2">{getSocialAccountName(account)}</Typography>
      </ListItemText>
      <ListItemSecondaryAction>
        {account.expires_soon ? renderRefresh() : renderValue()}
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default withStyles(styles)(ReachItem);
